@if (departments) {
  <div class="select-holder">
    <select (change)="selectDepartment()" [(ngModel)]="filter">
      <option [ngValue]="undefined">{{'filterDepartmentDefault' | translate}}</option>
      @for (department of departments; track department) {
        @if ((jobs |  search: 'function.label':department | numberOfKeys) !== 0) {
          <option [value]="department">
            {{ department | translate}}
            <span>({{jobs | search: 'function.label':department | numberOfKeys}})</span>
          </option>
        }
      }
    </select>
  </div>
}
